import { getCwContext, getDocumentElement } from './windowProperties';

export function normalizeLang(value) {
  let lang = value;
  if (!value) {
    return '';
  } else if (value.includes('-')) {
    lang = value.split('-')[0];
  } else if (value.includes('_')) {
    lang = value.split('_')[0];
  }
  if (lang.length !== 2) {
    return '';
  }
  return lang.toLowerCase();
}

export function logLanguageMismatch() {
  const docLang = normalizeLang(getDocumentElement().lang);
  // if no document language is found, there is nothing to compare against
  if (!docLang) {
    return;
  }
  const cwContext = getCwContext() || {};
  const cwLang = normalizeLang(cwContext.rsta);
  if (docLang !== cwLang) {
    console.error(`Language mismatch detected: document=${getDocumentElement().lang} cutils=${cwContext.rsta}`);
  }
}

export default function initLogLanguageMismatch() {
  window.addEventListener('DOMContentLoaded', logLanguageMismatch);
}
